import { useMemo, useState } from "react";
import { TbPlayerPlayFilled } from "react-icons/tb";
import { motion } from "framer-motion";
import { landingMotionInView } from "@/utils/landingMotion";

export default function LeaderboardSection() {
  
  

  // const [payoutImage, setPayoutImage] = useState<string>();
  // const [conditionImage, setConditionImage] = useState<string>();

  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const vimeoSrc = useMemo(() => {
    const base =
      "https://player.vimeo.com/video/1097867533?h=7486c2a0e7&badge=0&autopause=0&player_id=0&app_id=58479";
    return isVideoPlaying ? `${base}&autoplay=1` : base;
  }, [isVideoPlaying]);

  return (
    <div className="relative overflow-hidden text-white  pt-5 pb-10 ">
      <div className="z-0 mx-auto">
        
        <motion.div
          className="flex justify-center w-full "
          {...landingMotionInView}
        >
          <div className="w-full max-w-[1140px] mx-auto xl:px-0 px-4">
            <motion.div
              className="mx-auto  w-full border !p-4 border-white rounded-3xl bg-gradient-to-b from-white/10 to-white/5"
              {...landingMotionInView}
            >
              <motion.div
                className="relative h-[190px] md:h-[586px] !w-full overflow-hidden rounded-2xl bg-black/20"
                {...landingMotionInView}
              >
                {!isVideoPlaying && (
                  <button
                    type="button"
                    onClick={() => setIsVideoPlaying(true)}
                    className="absolute inset-0 z-10 flex items-center justify-center"
                    aria-label="Play video"
                  >
                    <div className="flex h-[76px] w-[76px] items-center justify-center rounded-full bg-gradient-to-br from-[#20CDE2]/70 to-[#D7D536]/70 backdrop-blur-md shadow-[0_10px_35px_rgba(0,0,0,0.35)] ring-1 ring-white/20 ">
                      <TbPlayerPlayFilled className="text-white text-2xl translate-x-[1px]" />
                    </div>
                  </button>
                )}
                <iframe
                  src={vimeoSrc}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                  allowFullScreen
                  title="Vimeo Video"
                  className="absolute inset-0 h-full w-full"
                  loading="lazy"
                />
              </motion.div>
            </motion.div>
          </div>
        </motion.div>

        

        {/* <div className="w-full hidden md:flex justify-center h-auto pb-[50px]">
          <GeneralButtonWithCss
            onClick={() =>
              scrollToFeatureSectionFunction(
                metaAccounts,
                isAuthenticated,
                navigate,
                featureSectionRef
              )
            }
            blur={true}
            className="text-[14px] sm:text-[15px] md:text-[18px] w-[124px] h-[32px] sm:w-[142] sm:h-[36.816px] md:w-[162px] md:h-[42px] 2k:text-[27px] 2k:w-[243px] 2k:h-[63px]"
            bgClassName="dark:bg-dark dark:opacity-30 dark:bg-none bg-gradient-to-r from-[#7DDEE9] via-[#BBE0A5] to-[#E4E389]"
          >
            {t("Start Challenge")}
          </GeneralButtonWithCss>
        </div> */}
      </div>
    </div>
  );
}
